import { QuestionnaireCategory, QuestionnaireQuestion } from '@/models/gen/graphql';
import { useDragItem, useDraggingGroup } from '@/features/Settings/pages/Questions/components/QuestionsTable/dragAndDrop';

import { Badge } from 'react-bootstrap';
import Button from '@/common/Button';
import HasPermission from '@/components/HasPermission';
import { ReactElement } from 'react';
import Table from '@/common/Table';
import { getClasses } from '@/utils';

type QuestionsTableRowProps = {
  question: QuestionnaireQuestion;
  category?: QuestionnaireCategory;
  index: number;
  draggable?: boolean;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
};

export const QuestionsTableRow = ({
  question,
  category,
  index,
  draggable = true,
  onEdit,
  onDelete,
}: QuestionsTableRowProps): ReactElement => {
  const { ref, handleRef, isDragging } = useDragItem({ id: question.id, group: question.questionnaireCategoryId }, index, !draggable);
  const draggingGroup = useDraggingGroup();
  const isFaded = draggingGroup !== undefined && draggingGroup !== question.questionnaireCategoryId;

  return (
    <Table.Row ref={ref} className={getClasses({ 'QuestionsTableRow--dragging': isDragging, 'QuestionsTableRow--faded': isFaded })}>
      <Table.Cell className="DRAG">
        <i ref={handleRef} className="sv sv-icons QuestionsTableRow-DragIcon" aria-hidden="true" />
      </Table.Cell>
      <Table.Cell className="ITEM">
        <div className="QuestionsTableRow-Item">
          <span className="QuestionsTableRow-Name">{question.helperText}</span>
          <span className="QuestionsTableRow-Description">{question.questionText}</span>
        </div>
      </Table.Cell>
      <Table.Cell className="CATEGORY">
        {category && (
          <Badge pill bg={null} style={{ backgroundColor: category.color }}>
            {category.name}
          </Badge>
        )}
      </Table.Cell>
      <HasPermission name="allowEditTrainingSettings">
        <Table.Cell className="ACTIONS">
          <div className="QuestionsTableRow-Actions">
            <Button
              type="button"
              variant="link"
              className="QuestionsTableRow-IconButton"
              aria-label={`Edit ${question.helperText}`}
              onClick={() => onEdit(question.id)}
            >
              <i className="sv sv-pencil" aria-hidden="true" />
            </Button>
            <Button
              type="button"
              variant="link"
              className="QuestionsTableRow-IconButton QuestionsTableRow-IconButton--danger"
              aria-label={`Delete ${question.helperText}`}
              onClick={() => onDelete(question.id)}
            >
              <i className="sv sv-trash2" aria-hidden="true" />
            </Button>
          </div>
        </Table.Cell>
      </HasPermission>
    </Table.Row>
  );
};
